__turbopack_context__.v({
  "buttonWrap": "HeroSection-module__pzGXVa__buttonWrap",
  "contentWrap": "HeroSection-module__pzGXVa__contentWrap",
  "ctaButton": "HeroSection-module__pzGXVa__ctaButton",
  "heroImage": "HeroSection-module__pzGXVa__heroImage",
  "heroSection": "HeroSection-module__pzGXVa__heroSection",
  "subtitle": "HeroSection-module__pzGXVa__subtitle",
  "title": "HeroSection-module__pzGXVa__title",
});
